import Cookies from 'js-cookie'

// 数据状态持久化
export const getCookie = (key:string) => Cookies.get(key)
export const setCookie = (key: string, val: string, options?: Cookies.CookieAttributes) => Cookies.set(key, val, options)
export const removeCookie = (key: string) => Cookies.remove(key)
